module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Generar OC",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "Razon Social",
      "required": "",
      "placeholder": "Razón Social"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha de liberacion")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.fecha),
      callback: function($$v) {
        _vm.fecha = $$v
      },
      expression: "fecha"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC (PDF)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveNIC()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])]), _vm._v(" "), _c('h3', [_vm._v(" Panel de control ")]), _vm._v(" "), (_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('th', {
      key: item.statusId,
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.statusList.length) + '%')
    }, [_vm._v("asd" + _vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('td', {
      key: item.statusId,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.statusId)
        }
      }
    }, [_vm._v(_vm._s(_vm.statusCount[item.statusId]))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.$route.path === '/buyOrders') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Nuevo...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', [_vm._v(" Filtros ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "OC",
      "clearable": ""
    },
    on: {
      "blur": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      },
      "clear": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    model: {
      value: (_vm.nicFilter),
      callback: function($$v) {
        _vm.nicFilter = $$v
      },
      expression: "nicFilter"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.statusId,
      attrs: {
        "value": item.statusId,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 19,
      "md": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(" Resultados ")]), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuyOrders),
      expression: "loadingBuyOrders"
    }],
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.buyOrders,
      "total": _vm.totalBuyOrders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getBuyOrders
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": title.sortable
      }
    })
  }), _vm._v(" "), (_vm.$route.path !== '/toBill') ? _c('el-table-column', {
    attrs: {
      "prop": "fecha_liberacion",
      "label": "Liberación",
      "sortable": "custom"
    }
  }) : _c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "prop": "documentDate",
      "label": "Documentación enviada"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getStatusName(scope.row.statusId)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Aceptado',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.view === '0' && (scope.row.statusId === '2' || scope.row.statusId === '3')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])]
      }
    }], null, false, 1839679790)
  }) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Tarea',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.documents) ? _c('span', [(scope.row.view === '0' && (scope.row.statusId === '4')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "No posee",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-minus"
        })])], 1)]
      }
    }], null, false, 4263317506)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrder)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5150ecc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Search.vue
// module id = 632
// module chunks = 1